<script>
	import { onMount, onDestroy } from 'svelte';
	import Link from 'svelte-link';
	import {
		Row, Col, CardBody, Card, Container, Form,
		Label, Input, Button, Alert
	} from '@sveltestrap/sveltestrap';
	import profileImg from '../../../assets/images/profile-img.png';
	import logolight from '../../../assets/images/logo-light.svg';
	import logo from '../../../assets/images/logo.svg';
	import { DoLogin, authCheck } from '../../../services/auth.js';
	import { createEventDispatcher } from 'svelte';
	import { get } from 'svelte/store';
	import { userObj } from '../../../stores/authUserStore.js';
	import { base } from '$app/paths';
	import { goto } from '$app/navigation';

	export let onRegister = undefined;

	let username = '';
	let password = '';
	let isOpen = false;
	let msg = '';
	let status = '';

	const dispatch = createEventDispatcher();

	onMount(() => {
		// focus on the username text field
		console.log('Login page mounted');
		// add a time to call focus after 1 second

		const focusTimeout = setTimeout(() => {
			let u_el = document.getElementById('username');
			u_el?.focus();
		}, 500);
		return () => clearTimeout(focusTimeout);
	});

	onDestroy(() => {
		// cleanup
	});

	async function onSubmit(e) {
		e.preventDefault();
		if (!username || !password) {
			isOpen = true;
			msg = 'Please enter username and password';
			status = 'danger';
			return;
		}

		try {
			let login_res = await DoLogin(username, password);
			if (login_res['status'] === 'success') {
				const _userObj = get(userObj);
				if (_userObj.Authenticated === 'true') {
					msg = 'Authentication success';
					isOpen = true;
					status = 'success';
					// tell parent model to close
					dispatch('loginSuccess');
				} else {
					msg = 'Authentication failed';
					isOpen = true;
					status = 'danger';
				}
			} else {
				isOpen = true;
				msg = login_res['detail'];
				status = 'danger';
				const error = login_res['detail'] || 'An error occurred';
				msg = error;
				return error;
			}
		} catch (error) {
			console.error('Error:', error);
			return 'An error occurred';
		}
	}

	let showPassword = false;

	function togglePasswordVisibility() {
		showPassword = !showPassword;
	}

	function gotoSignup() {
		if (onRegister) {
			onRegister();
			return;
		}
		goto(`${base}/auth/register`);
		dispatch('loginSuccess');
	}

</script>

<div class="account-pages">
	<Container>
		<Row class="justify-content-center">
			<Col>
				<Card class="overflow-hidden">
					<div class="bg-primary-subtle">
						<Row>
							<Col class="col-7">
								<div class="text-primary p-4">
									<h5 class="text-primary">Welcome</h5>
									<p>Sign in to continue to D-Cine Cinema Tools.</p>
								</div>
							</Col>
							<Col class="col-5 align-self-end">
								<img src={profileImg} alt="" class="img-fluid" />
							</Col>
						</Row>
					</div>
					<CardBody class="pt-0">
						<div class="auth-logo">
							<Link href="{base}/welcome" class="auth-logo-light">
								<div class="avatar-md profile-user-wid mb-4">
									<span class="avatar-title rounded-circle bg-light">
										<img src={logolight} alt="" class="rounded-circle" height="34" />
									</span>
								</div>
							</Link>
							<Link href="{base}/welcome" class="auth-logo-dark">
								<div class="avatar-md profile-user-wid mb-4">
									<span class="avatar-title rounded-circle bg-light">
										<img src={logo} alt="" class="rounded-circle" height="34" />
									</span>
								</div>
							</Link>
						</div>
						<div class="p-2">
							<Alert {isOpen} color={status}>{msg}</Alert>
							{#if status !== 'success'}

								<Form class="form-horizontal" on:submit={onSubmit}>
									<div class="mb-3">
										<Label for="username" class="form-label">Username</Label>
										<Input
											type="text"
											class="form-control"
											id="username"
											placeholder="Enter username"
											bind:value={username}
										/>
									</div>

									<div class="mb-3">
										<Label class="form-label" for="user-password">Password</Label>
										<div class="input-group auth-pass-inputgroup">
											<Input
												type={showPassword ? 'text' : 'password'}
												class="form-control"
												id="user-password"
												placeholder="Enter password"
												aria-label="Password"
												aria-describedby="password-addon"
												bind:value={password}
											/>
											<Button
												color="light"
												type="button"
												id="password-addon"
												on:click={togglePasswordVisibility}>
												<i class="mdi mdi-eye-outline"></i>
											</Button>
										</div>
									</div>

									<!--								<div class="form-check">-->
									<!--									<input class="form-check-input" type="checkbox" id="remember-check" />-->
									<!--									<Label class="form-check-label" for="remember-check">Remember me</Label>-->
									<!--								</div>-->

									<div class="mt-3 d-grid">
										<Button color="primary" class="waves-effect waves-light" type="submit"
										>Log In
										</Button>
									</div>

									<div class="mt-4 text-center">
										<Link href="{base}/auth/recoverpw" class="text-muted"
										><i class="mdi mdi-lock me-1"></i> Forgot your password?
										</Link>
									</div>
								</Form>
							{/if}
						</div>
					</CardBody>
				</Card>
				<div class="mt-5 text-center">
					<p>
						Don&apos;t have an account ?
						<button class="btn btn-link p-0 fw-medium"
							 type="button"
							 on:click={gotoSignup}>Signup now</button>
					</p>
					<p>
						© {new Date().getFullYear()} D-Cine
					</p>
				</div>
			</Col>
		</Row>
	</Container>
</div>
